import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMonthReservations } from "../../../features/reservation/thunks";

const useMonthReservation = (selectedMonth) => {
  const dispatch = useDispatch();
  const monthReservations = useSelector(
    (state) => state.reservation?.monthReservations || []
  );

  useEffect(() => {
    const currentMonth = selectedMonth || new Date();
    const annee = currentMonth.getFullYear();
    const mois = currentMonth.getMonth() + 1;

    dispatch(fetchMonthReservations({ annee, mois }));
  }, [dispatch, selectedMonth]);

  return monthReservations;
};

export default useMonthReservation;
